import {
  IconButton as CXIconButton,
  ICON_BUTTON_VARIANT as CXButtonVariant,
  ICON_BUTTON_SIZE as CXButtonSize
} from '@sanlamcx/react-ui-next-icon-button';

export const IconButton = CXIconButton;
export type ICON_BUTTON_VARIANT = CXButtonVariant;
export type ICON_BUTTON_SIZE = CXButtonSize;
